import React from 'react';
import styled from 'styled-components';

import Message2 from '../Message2';
import Messenger from '../Messenger';
import { ExcessTicketType } from '@components/CRM/Tickets/types';

interface ExcessTicketHistoryProps {
  ticket: ExcessTicketType;
  isExpanded: boolean;
  onToggle: (ticketId: string) => void;
}

const ExcessTicketHistory = ({
  ticket,
  isExpanded,
  onToggle,
}: ExcessTicketHistoryProps) => {
  const { chain } = ticket;

  if (!chain) return null;

  return (
    <StyledContainer>
      <StyledToggle type="button" onClick={() => onToggle(ticket.id)}>
        <StyledMessenger type={chain.type} />
        <span>
          История сообщений из закрытого тикета-дубликата №{ticket.id}
        </span>
        <StyledHint>{isExpanded ? 'Свернуть' : 'Развернуть'}</StyledHint>
      </StyledToggle>
      {isExpanded && (
        <StyledMessages>
          {chain.messages.map(({ client, message }) => (
            <Message2
              key={message.id}
              client={{
                avatarUrl: client?.avatarUrl || undefined,
                email: client?.email,
                fullName: client?.fullName,
                number: client?.phone,
              }}
              message={message}
              isEmail={false}
              isClosedTicket
              onForwardMessage={() => undefined}
              onLoadHistoryMessages={() => undefined}
              onRevealServiceMessages={() => undefined}
            />
          ))}
        </StyledMessages>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  background-color: #f5f3f2;
  padding: 8px 10px;
`;

export const StyledToggle = styled.button`
  align-items: center;
  background: #eeecea;
  border: 0;
  border-radius: 4px;
  color: #007aff;
  cursor: pointer;
  display: flex;
  font: inherit;
  padding: 7px 10px;
  text-align: left;
  width: 100%;
`;

const StyledMessenger = styled(Messenger)`
  height: 18px;
  margin-right: 8px;
  width: 18px;
`;

const StyledHint = styled.span`
  color: #919499;
  font-size: 12px;
  margin-left: auto;
  padding-left: 10px;
`;

const StyledMessages = styled.div`
  margin-top: 8px;
`;

export default ExcessTicketHistory;
